import Immutable from "immutable";
import * as types from "./constants";

const initialState = null;

const workareaReducer = (state = Immutable.fromJS(initialState), action) => {
  switch (action.type) {
    case types.SIGN_OUT_COMPLETE:
      return initialState;
    case types.WORKAREA_SET:
      return action.payload;
    default:
      return state;
  }
};

export default workareaReducer;
